import { render, staticRenderFns } from "./IGChannelDetail.vue?vue&type=template&id=9e878584&scoped=true"
import script from "./IGChannelDetail.vue?vue&type=script&lang=js"
export * from "./IGChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./IGChannelDetail.vue?vue&type=style&index=0&id=9e878584&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e878584",
  null
  
)

export default component.exports